import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const Sale = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      <path
        d="M9.15 20C8.9 20 8.65 19.95 8.4 19.85C8.15 19.75 7.92 19.6 7.72 19.4L0.58 12.25C0.38 12.05 0.23 11.83 0.14 11.59C0.05 11.35 0 11.1 0 10.85C0 10.6 0.05 10.35 0.14 10.1C0.23 9.85 0.38 9.62 0.58 9.42L9.38 0.6C9.56 0.42 9.78 0.27 10.03 0.16C10.28 0.05 10.54 0 10.81 0H17.99C18.54 0 19.01 0.2 19.4 0.59C19.79 0.98 19.99 1.45 19.99 2V9.18C19.99 9.45 19.94 9.7 19.84 9.94C19.74 10.18 19.6 10.39 19.41 10.58L10.58 19.41C10.38 19.61 10.15 19.76 9.9 19.86C9.65 19.96 9.4 20.01 9.15 20.01V20ZM9.15 18L17.98 9.15V2H10.83L2 10.85L9.15 18ZM15.48 6C15.9 6 16.25 5.85 16.54 5.56C16.83 5.27 16.98 4.91 16.98 4.5C16.98 4.09 16.83 3.73 16.54 3.44C16.25 3.15 15.89 3 15.48 3C15.07 3 14.71 3.15 14.42 3.44C14.13 3.73 13.98 4.09 13.98 4.5C13.98 4.91 14.13 5.27 14.42 5.56C14.71 5.85 15.07 6 15.48 6Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default Sale;
